export default function initFacebookShare() {
  // set up facebook sdk
  window.fbAsyncInit = function init() {
    window.FB.init({
      appId: '1923608234577445',
      xfbml: true,
      version: 'v2.9'
    });
    window.FB.AppEvents.logPageView();
  };

  (function load(d, s, id) {
    let js = null;
    const fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) { return; }
    js = d.createElement(s);
    js.id = id;
    js.src = '//connect.facebook.net/zh_TW/sdk.js';
    fjs.parentNode.insertBefore(js, fjs);
  }(document, 'script', 'facebook-jssdk'));
}



// WEBPACK FOOTER //
// ./app/utils/facebook-handler.js